import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { scrollToTop } from './services/scrolling';

class ScrollToTop extends React.Component<RouteComponentProps> {
  componentDidUpdate(prevProps: RouteComponentProps) {
    if (this.props.location !== prevProps.location) {
      scrollToTop();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/ScrollToTop.ts